const registrationSteps = {
    collectBasicData: 1,
    collectAddressData: 2,
    voucher: 3
};


export default {
    registrationSteps,
};